import { api } from '../configs';
import { isLoading } from './index';
import { sendApiToGaEvent, sendGaEvent } from '../helpers';

const submitPlainRegistrationSuccess = () => ({
  type: 'SET_SUBMIT_PLAIN_REGISTRATION_SUCCESS'
});

const submitPlainRegistrationError = errorType => ({
  type: 'SET_SUBMIT_PLAIN_REGISTRATION_ERROR',
  errorType
});

export const resetPlainRegistrationState = () => ({
  type: 'RESET_PLAIN_STATE'
});

export const setPlainSessionExpired = () => ({
  type: 'SET_PLAIN_SESSION_EXPIRED'
});

export const clearPlainSessionExpired = () => ({
  type: 'CLEAR_PLAIN_SESSION_EXPIRED'
});

export const setPlainCustomerDetails = customer => ({
  type: 'SET_PLAIN_CUSTOMER_DETAILS',
  customer
});

export const clearPlainError = () => ({
  type: 'CLEAR_PLAIN_ERROR'
});

export function submitPlainRegistration(
  campaignId,
  customer,
  okToContact,
  selectedProducts = {},
  { gReCaptchaResponse } = {}
) {
  const url = api.plain.submitRegistration.replace(':campaignId', campaignId);

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      gReCaptchaResponse: gReCaptchaResponse,
      name: customer.name,
      email: customer.email,
      mobile: customer.mobile,
      okToContact: okToContact,
      portIn: customer.portIn || false,
      productIds: Object.keys(selectedProducts).map(
        product => selectedProducts[product].id
      )
    })
  };

  return dispatch => {
    dispatch(isLoading(true));

    return fetch(url, options)
      .then(async response => {
        sendApiToGaEvent('submitPlainRegistration', response.status);
        dispatch(isLoading(false));
        if (response.status >= 200 && response.status < 300) {
          Object.keys(selectedProducts).forEach(product =>
            sendGaEvent('Plain Products', selectedProducts[product].description)
          );

          sendGaEvent('Plain Count', Object.keys(selectedProducts).length);
          sendGaEvent('Plain OkToContact', okToContact);

          dispatch(submitPlainRegistrationSuccess());

          return response.json();
        }
        if (response.status === 400) {
          // check if it's a duplicate registration error
          const errorData = await response.json().catch(() => ({}));
          if (
            errorData.message &&
            errorData.message.includes('already exists')
          ) {
            dispatch(submitPlainRegistrationError('DUPLICATE_REGISTRATION'));
          } else if (
            errorData.message &&
            errorData.message.includes('not allowed')
          ) {
            dispatch(submitPlainRegistrationError('CAMPAIGN_NOT_ALLOWED'));
          } else {
            dispatch(submitPlainRegistrationError('BAD_REQUEST'));
          }
        } else if (response.status === 409) {
          dispatch(submitPlainRegistrationError('DUPLICATE_REGISTRATION'));
        } else {
          dispatch(submitPlainRegistrationError('UNKNOWN_ERROR'));
        }
      })
      .catch(() => {
        dispatch(isLoading(false));
        dispatch(submitPlainRegistrationError('NETWORK_ERROR'));
      });
  };
}
